import React from 'react';
import {createRoot} from 'react-dom/client';
import App from '../components/App';
import store from './store'
import {Provider} from 'react-redux'

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App/>
    </React.StrictMode>
  </Provider>
);
